export const STATUS_COLOR_MAP: Record<string, string> = {
  online: "bg-emerald-500 dark:bg-emerald-400",
  idle: "bg-amber-500 dark:bg-amber-400",
  offline: "bg-gray-400 dark:bg-gray-500",
};

export const SIDE_MAP: Record<string, "top" | "right" | "bottom" | "left"> = {
  top: "top",
  bottom: "bottom",
  left: "left",
  right: "right",
  auto: "bottom",
};

export const XL_CLASSES =
  "data-[size=lg]:size-16 [&>[data-slot=avatar-badge]]:size-4 [&>[data-slot=avatar-fallback]]:text-lg";
